import React, { Component } from "react";
import UpdateContactDetails from "./UpdateContactDetails";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";

/**
 * ContactDetails Component for displaying the candidate contact details.
 */
class ContactDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      validid: false,
      isOpen: false,
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
  }
  // openAddForm
  openAddForm() {
    this.setState({
      addBtn: true,
    });
  }
   // closing Add form(toggling)
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }
  // openUpdateForm
  openUpdateForm() {
    this.setState({
      updateBtn: true,
    });
  }
  // closeUpdateForm
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.getData();
  }

  componentDidMount() {
    this.getData();
  }
 // geting candidate contact detail
  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-contact`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  render() {
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
      {/* applied ternary operator */}
        {!addBtn && !updateBtn ? (
          <>
            <div
              style={{
                height: "40px",
                display: "flex",
                flexDirection: "row",
                // justifyContent: "flex-end",
                // alignItems: "center",
              }}
            >
              <div style={{width:"60%",display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                <h5 style={{ fontWeight: 500,fontSize:"1.25rem" }}>Contact Details</h5>
              </div>

              <div style={{width:"40%"}}>
                <i
                  style={{
                    marginRight: "80px",
                    marginTop: "5px",
                    color: "green",
                  }}
                  className="material-icons pointer contact-edit-btn"
                  onClick={this.openUpdateForm}
                >
                  edit
                </i>
              </div>
            </div>

            <ul>
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Alternative Contact No.
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ?   ` ${data[0].dialingCode } ${data[0].alternateContactNo}` : null}
                  </div>
                </div>
              </li>
              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Alternative Email Id
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].alternateEmailId : null}
                  </div>
                </div>
              </li>

              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Current Address
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].currentAddress : null}
                  </div>
                </div>
              </li>

              <li>
                <div className="details-flex-main-div">
                  <div className="contact-details-flex-div-one">
                    Permanent Address
                  </div>
                  <div className="details-flex-div-two">:</div>
                  <div className="details-flex-div-three">
                    {data.length ? data[0].permanentAddress : null}
                  </div>
                </div>
              </li>
            </ul>
          </>
        ) : null}
        {updateBtn && (
          <UpdateContactDetails back={this.closeUpdateForm} data={data} />
        )}
      </>
    );
  }
}

export default ContactDetails;
